// Expose Educational Content Page
export * from './educational-content-page/educational-content-page.component';
export * from './educational-content-page/mocks/benefits.mocks';
export * from './educational-content-page/mocks/educational-content-page.mocks';
export * from './educational-content-page/mocks/ways.mocks';
export * from './educational-content-page/models/educational-content-page.interfaces';
